<template>
  <div class="WorkersSection">
    <form-section
      id="organization-section"
      :title="title"
      :is-first-section="false"
      :hasErrors="hasSectionErrors(errors, 'workers')"
    >
      <WorkersList
        :identifications="identifications"
        :nationalities="nationalities"
        :workers="workers"
        :removeWorker="removeWorker"
        :moveWorkerToVisitor="moveWorkerToVisitor"
        :setResponsibleWorker="setResponsibleWorker"
        :unsetResponsibleWorker="unsetResponsibleWorker"
      />

      <a class="text-success"
         :style="{textDecoration: 'underline', cursor: 'pointer'}"
         v-if="!expandedVisitorsList"
         @click="expandedVisitorsList = !expandedVisitorsList"
      >
        Выбрать из списка посетителей
      </a>
      <a class="text-success"
         :style="{textDecoration: 'underline', cursor: 'pointer'}"
         v-else
         @click="expandedVisitorsList = !expandedVisitorsList"
      >
        Скрыть список посетителей
      </a>

      <NewWorkerForm
        :addWorker="moveTypeaheadToWorker"
      />
      <VisitorsSelectList
        v-if="expandedVisitorsList"
        :nationalities="nationalities"
        :identifications="identifications"
        :visitors="visitors"
        :moveVisitorToWorker="moveVisitorToWorker"
      />
    </form-section>
  </div>
</template>

<script>
import FormSection from '../application/FormSection'
import hasErrorsMixin from '../../mixins/hasErrorsMixin'
import NewWorkerForm from './NewWorkerForm'
import WorkersList from './WorkersList'
import VisitorsSelectList from './VisitorsSelectList'

export default {
  name: 'WorkersSection',

  mixins: [hasErrorsMixin],

  components: {
    FormSection,
    WorkersList,
    NewWorkerForm,
    VisitorsSelectList
  },

  props: {
    setResponsibleWorker: {
      type: Function
    },

    unsetResponsibleWorker: {
      type: Function
    },

    addWorker: {
      type: Function,
      required: true
    },

    removeWorker: {
      type: Function,
      required: true
    },

    addVisitor: {
      type: Function,
      required: true
    },

    removeVisitor: {
      type: Function,
      required: true
    },

    /**
     * Identification document type
     */
    identifications: {
      type: Array
    },

    /**
     * Flags icons
     */
    nationalities: {
      type: Array
    },

    /**
     * Errors
     */
    errors: {
      type: [Array, Object]
    },

    /**
     * Section type
     */
    title: {
      type: String
    },

    /**
     * Visitors section for select
     */
    visitors: {
      type: Array
    },

    /**
     * Rest type application workers list
     */
    workers: {
      type: Array
    }
  },

  data: () => {
    return {
      expandedVisitorsList: false
    }
  },

  methods: {
    moveTypeaheadToWorker (visitor = {}) {
      this.addWorker(visitor)
    },

    moveVisitorToWorker (index) {
      let visitor = this.removeVisitor(index)
      visitor[0].responsible = false
      this.addWorker(...visitor)
    },

    moveWorkerToVisitor (index) {
      let visitor = this.removeWorker(index)
      visitor[0].responsible = false
      if (!visitor[0].new === true) {
        this.addVisitor(...visitor)
      }
    }
  }
}
</script>
